import React, { useContext, useMemo } from 'react';
import { browserHistory } from 'react-router';
import { AntdPageHeader, colors } from '@yuhuinc/ui-library';
import { Tag } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from './ApplicationOverview';

const ApplicationHeader = ({ subTitle }) => {
  const application = useContext(CurrentApplicationContext);
  const queryClient = useQueryClient();

  const { lifecycle } = application;

  const statusAndSubstatus = useMemo(() => {
    if (!lifecycle) {
      return [];
    }

    return [
      <Tag color={colors.TAG_STATUS_COLORS.application[lifecycle.status]} key="status">
        {lifecycle.status_label}
      </Tag>,
      <Tag color={colors.TAG_STATUS_COLORS.application[lifecycle.substatus]} key="substatus">
        {lifecycle.substatus_label}
      </Tag>,
    ];
  }, [lifecycle]);

  return (
    <AntdPageHeader
      onBack={() => {
        browserHistory.push('/companies/applications');
        queryClient.invalidateQueries({ queryKey: ['applications'] });
      }}
      title={getTranslatedString('landlordPortal.applicationManagement.applicationOverview')}
      subTitle={subTitle}
      tags={statusAndSubstatus}
    />
  );
};

export default ApplicationHeader;
